import { createFileRoute } from '@tanstack/react-router';
import { MeLayout } from '@/app/shell/me-layout';

/** The signed-in user's own pages (/me/…): the app shell around every page. */
export const Route = createFileRoute('/_auth/me')({
  component: MeLayout,
});
